/**
 *  @class
 *  @function RichTextElement
 */

if (!customElements.get('rich-text')) {
  class RichTextElement extends HTMLElement {
    constructor() {
      super();

      this.tl = false;
      this.splittext = false;
    }
    connectedCallback() {
      if (document.body.classList.contains('animations-true') && typeof gsap !== 'undefined') {
        this.prepareAnimations();
      }
    }
    disconnectedCallback() {
      if (document.body.classList.contains('animations-true') && typeof gsap !== 'undefined') {
        if (this.tl) {
          this.tl.kill();
        }
        if (this.splittext) {
          this.splittext.revert();
        }
      }
    }
    prepareAnimations() {
      let section = this,
        button_offset = 0;

      section.tl = gsap.timeline({
        scrollTrigger: {
          trigger: section,
          start: "top center"
        }
      });

      document.fonts.ready.then(function () {
        section.splittext = new SplitText(section.querySelectorAll('h1, h2, h3, h4, h5, h6, .rte p, .rte div'), {
          type: 'lines, words',
          linesClass: 'line-child'
        });

        let subheading = section.querySelector('.subheading');
        if (subheading) {
          section.tl
            .fromTo(subheading, {
              opacity: 0
            }, {
              duration: 0.75,
              opacity: 0.6
            }, 0);

          button_offset += 0.5;
        }

        let headings = section.querySelectorAll('h1, h2, h3, h4, h5, h6');
        if (headings.length) {
          let headingLines = section.querySelectorAll('h1 .line-child div, h2 .line-child div, h3 .line-child div, h4 .line-child div, h5 .line-child div, h6 .line-child div');
          if (headingLines.length) {
            let h3_duration = 0.8 + ((headingLines.length - 1) * 0.08);
            section.tl
              .set(headings, {
                visibility: 'visible'
              }, 0)
              .from(headingLines, {
                duration: h3_duration,
                yPercent: '100',
                stagger: 0.08
              }, 0);
            button_offset += h3_duration;
          }
        }

        let rteParagraphs = section.querySelectorAll('.rte p, .rte div');
        if (rteParagraphs.length) {
          let rteLines = section.querySelectorAll('.rte p .line-child div, .rte div .line-child div');
          if (rteLines.length) {
            let p_duration = 0.8 + ((rteLines.length - 1) * 0.02);
            section.tl
              .set(rteParagraphs, {
                visibility: 'visible'
              }, 0)
              .from(rteLines, {
                duration: p_duration,
                yPercent: '100',
                stagger: 0.02
              }, 0);
            button_offset += p_duration;
          }
        }

        let buttons = section.querySelectorAll('.button, .text-button');
        if (buttons.length) {
          buttons.forEach((item, index) => {
            section.tl.fromTo(item, {
              autoAlpha: 0
            }, {
              duration: 0.5,
              autoAlpha: 1
            }, ((button_offset * 0.4) + index * 0.1));
          });
        }

      });
    }
  }
  customElements.define('rich-text', RichTextElement);
}
